import type { CollectiveGroupResponse } from '@on3/api';
import { formatCurrency } from '@on3/ui-lib/utils/formatters';
import { ResizedImage } from 'components/Image/ResizedImage';
import { TeamAvatar } from 'components/Image/TeamAvatar';
import { SidebarWrapper } from 'components/UI/Layout/Containers/Sidebar/SidebarWrapper';
import { Text } from 'components/UI/Typography/Text';
import { format } from 'date-fns';

import styles from './CollectiveGroupModule.module.scss';

interface props {
  data: CollectiveGroupResponse;
}

export const CollectiveGroupModule = ({ data }: props) => {
  const {
    name,
    defaultAsset,
    organization,
    launchDate,
    organizationType,
    websiteUrl,
    annualGoalAmount,
    confirmedRaisedAmount,
  } = data;
  const hasImage = defaultAsset?.source;

  return (
    <SidebarWrapper className={styles.collectiveGroup}>
      <div className={styles.branding}>
        <div className={styles.teamContainer}>
          <TeamAvatar
            className={styles.teamLogo}
            height={50}
            slug={organization?.fullName}
            src={organization?.assetUrl}
            width={50}
          />
          <Text className={styles.orgName}>{organization?.fullName}</Text>
        </div>
        {/* We need the height/width to populate here so we can pass it in */}
        {hasImage && (
          <div className={styles.logoWrapper}>
            {websiteUrl && (
              <a href={websiteUrl} rel="noopener noreferrer" target="_blank">
                <ResizedImage
                  className={styles.collectiveLogo}
                  {...defaultAsset}
                  altText={`${name} Logo`}
                  fit="cover"
                  height={90}
                  quality={90}
                />
              </a>
            )}
            {!websiteUrl && (
              <ResizedImage
                className={styles.collectiveLogo}
                {...defaultAsset}
                altText={`${name} Logo`}
                fit="cover"
                height={90}
                quality={90}
              />
            )}
          </div>
        )}
      </div>

      <div className={styles.itemContainer}>
        <Text className={styles.label} variant="subtitle1">
          launch date
        </Text>
        <Text className={styles.value}>
          {launchDate ? format(new Date(launchDate), 'MMM yyyy') : 'No Data'}
        </Text>
      </div>
      <div className={styles.itemContainer}>
        <Text className={styles.label} variant="subtitle1">
          status
        </Text>
        <Text className={styles.value}>{organizationType}</Text>
      </div>
      <div className={styles.itemContainer}>
        <Text className={styles.label} variant="subtitle1">
          annual goal
        </Text>
        <Text className={styles.value}>
          {annualGoalAmount ? formatCurrency(annualGoalAmount) : 'No Data'}
        </Text>
      </div>
      <div className={styles.itemContainer}>
        <Text className={styles.label} variant="subtitle1">
          confirmed raise
        </Text>
        <Text className={styles.value}>
          {confirmedRaisedAmount
            ? formatCurrency(confirmedRaisedAmount)
            : 'No Data'}
        </Text>
      </div>
    </SidebarWrapper>
  );
};
